import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

/**
 * Vuex全局状态管理
 * @param options {Array} 用于渲染tabs的数组
 */
const store = new Vuex.Store({
  state: {
    cachePages: [],
    options: [],
    activeIndex: "/",
    userInfo: {},
    loading: true,
    refreshProductList: false,
    iconPath: "/",
    reloadPages: [], //需要重新加载的页面
    showNva: eval(localStorage.isYinXin), //显示左侧导航条
    fullScreen: false, //  是否显示全屏
    orderState: null,
    warningType: 0,
    hasNewMsg: false,
    isLogOut: false,
    orderId: null,
    splitId: null,
    printData: [],
    orderPage: {},
    workPage: {
      activeName: "tool"
    },
    customPintInfo: {},
    isReload: false,
    pointDetailData: {},
    deviceInfo: {}
  },
  mutations: {
    reload_store(state) {
      //退出登录时清除保存的state信息
      state.cachePages = [];
      state.options = [];
      state.activeIndex = "/";
      state.userInfo = {};
      (state.loading = true), (state.refreshProductList = false);
      state.iconPath = "/";
      state.reloadPages = [];
      state.showNva = eval(localStorage.isYinXin);
      state.fullScreen = false;
      state.orderState = null;
      state.warningType = 0;
      state.isLogOut = false;
      state.orderId = null;
      state.splitId = null;
      state.printData = [];
      state.orderPage = {};
      state.workPage = { activeName: "tool" };
      state.isReload = false;
      state.pointDetailData = {};
      state.deviceInfo = {};
    },
    enterFullScreen(state) {
      //进入全屏
      state.fullScreen = true;
    },
    exitFullScreen(state) {
      //退出全屏
      state.fullScreen = false;
    },
    changeNvaState(state) {
      if (state.showNva) {
        localStorage.setItem("isYinXin", false);
      } else {
        localStorage.setItem("isYinXin", true);
      }
      state.showNva = !state.showNva;
    },
    add_reloadPages(state, pages) {
      pages.forEach(item => {
        if (state.reloadPages.indexOf(item) == -1) {
          state.reloadPages.push(item);
        }
      });
    },
    delete_reloadPages(state, path) {
      let index = state.reloadPages.indexOf(path);
      if (index > -1) {
        state.reloadPages.splice(index, 1);
      }
    },
    submitProduct(state) {
      state.refreshProductList = true;
    },
    cacheProductList(state) {
      state.refreshProductList = false;
    },
    loading(state) {
      state.loading = true;
    },
    unloading(state) {
      state.loading = false;
    },
    add_tabs(state, data) {
      for (let option of state.options) {
        if (option.fullPath === data.fullPath) {
          return;
        }
      }
      if (data.name != "ProductionReportInfo") {
        this.state.cachePages.push(data.name);
      }
      this.state.options.push(data);
      if (state.options.length > 10) {
        let item = state.options[1];
        state.options.splice(1, 1);
        state.cachePages = state.cachePages.filter(f => f != item.name);
      }
    },
    // 删除tabs
    delete_tabs(state, route) {
      let index = 0;
      for (let option of state.options) {
        if (option.fullPath === route) {
          let seq = state.cachePages.indexOf(option.name);
          if (seq > 0) {
            state.cachePages.splice(seq, 1);
          }
          break;
        }
        index++;
      }
      state.options = state.options.filter(item => item.fullPath != route);
    },
    clear_tabs(state) {
      state.options = [];
      state.cachePages = [];
    },
    keep_tabs(state, { tabs, options }) {
      state.cachePages = tabs;
      state.options = options;
    },
    // 设置当前激活的tab
    set_active_index(state, index) {
      this.state.activeIndex = index;
    },
    // 设置详情信息
    save_detail_info(state, info) {
      this.state.userInfo = info;
    },
    changeIconPath(state, path) {
      this.state.iconPath = path;
    },
    changeOrderState(state, num) {
      this.state.orderState = num;
    },
    changeOrderPage(state, num) {
      this.state.orderPage = num;
    },
    changeWorkPage(state, obj) {
      log(obj);
      this.state.workPage = obj;
    },
    changeWarningType(state, num) {
      this.state.warningType = num;
    },
    changeMsgState(state, type) {
      if (type == true) {
        let find = this.state.options.find(item => item.name == "MessageCenter");
        if (find) {
          this.state.hasNewMsg = true;
        }
      } else {
        this.state.hasNewMsg = false;
      }
    },
    changeLogOUtStatus(state, isLogOut) {
      this.state.isLogOut = isLogOut;
    },
    setOrderId(state, orderId) {
      state.orderId = orderId;
    },
    setSplitId(state, splitId) {
      state.splitId = splitId;
    },
    setPrintData(state, data) {
      state.printData = data;
    },
    setReloadStatus(state, data) {
      state.isReload = data;
    },

    add_printInfo(state, info) {
      state.customPintInfo = info;
    },
    setPointDetailData(state, data) {
      state.pointDetailData = data;
    },
    setDeviceInfo(state, info) {
      state.deviceInfo = info;
    }
  },
  getters: {
    cachePages(context) {
      return context.cachePages;
      return [...new Set(context.cachePages)];
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js